export default {
  computed: {
    fields() {
      return [
        {
          label: this.$t('delivery.fields.doNumber'),
          key: 'external_number',
        },
        {
          label: this.$t('delivery.fields.customerName'),
          key: 'external_customer_name',
        },
        {
          label: this.$t('delivery.fields.destinationAddress'),
          key: 'destination_address',
        },
        {
          label: this.$t('delivery.fields.deliveryTarget'),
          key: 'external_date',
        },
        {
          label: this.$t('delivery.fields.lastCreatedInMEP'),
          key: 'integrated_on',
        },
        {
          label: this.$t('delivery.fields.mepDeliveryNumber'),
          key: 'delivery_order_numbers',
          isRedirectable: true,
        },
        {
          label: this.$t('delivery.fields.mepDeliveryStatus'),
          key: 'status.name',
        },
        {
          label: '',
          key: 'action',
          isSortable: false,
          thClass: 'text-center',
          tdClass: 'action-center'
        }
      ]
    }
  }
}
